
export default {
    en: { testNamespace: { testKey: 'English language' } },
    fr: { testNamespace: { testKey: 'langue français' } },
};
